/**
 * @file Mini jQuery ٩(◕‿◕｡)۶
 *
 * This library aim is to simplify DOM manipulation.
 */

/**
 * @param {string} value Data which is attempted to be parsed to a more accurate type
 * @returns {boolean|number|null|string} parsedValue
 */
function normalizeData(value) {
	if (value === 'true') {
		return true;
	}

	if (value === 'false') {
		return false;
	}

	if (value === Number(value).toString()) {
		return Number(value);
	}

	if (value === '' || value === 'null') {
		// eslint-disable-next-line unicorn/no-null
		return null;
	}

	return value;
}

/**
 * @param {string} key Text to be converted
 * NB: if `key` starts with uppercase character, this will return with a leading hyphen.
 * @returns {string} A kebab-cased version of the value
 */
function normalizeDataKey(key) {
	return key.replace(/[A-Z]/g, (chr) => `-${chr.toLowerCase()}`);
}

const Manipulator = {
	setDataAttribute(element, key, value) {
		element.setAttribute(`data-${normalizeDataKey(key)}`, value);
	},

	removeDataAttribute(element, key) {
		element.removeAttribute(`data-${normalizeDataKey(key)}`);
	},

	/**
	 * Get all data attributes from an element.
	 *
	 * @param {Element} element HTML element
	 * @returns {object} Data attributes object
	 */
	getDataAttributes(element) {
		if (!element) {
			return {};
		}

		const attributes = {
			...element.dataset
		};

		for (const key of Object.keys(attributes)) {
			attributes[key] = normalizeData(attributes[key]);
		}

		return attributes;
	},

	getDataAttribute(element, key) {
		return normalizeData(element.getAttribute(`data-${normalizeDataKey(key)}`));
	},

	offset(element) {
		const rect = element.getBoundingClientRect();

		return {
			top: rect.top + document.body.scrollTop,
			left: rect.left + document.body.scrollLeft
		};
	},

	position(element) {
		return {
			top: element.offsetTop,
			left: element.offsetLeft
		};
	},

	toggleClass(element, className) {
		if (!element) {
			return;
		}

		if (element.classList.contains(className)) {
			element.classList.remove(className);
		} else {
			element.classList.add(className);
		}
	},

	/**
	 * Add or remove a class based on a conditional boolean
	 *
	 * @param {HTMLElement} element - DOM Element
	 * @param {string} className - CSS class
	 * @param {boolean} bool - Conditional boolean
	 */
	toggleClassCond(element, className, bool) {
		if (bool) {
			element.classList.add(className);
		} else {
			element.classList.remove(className);
		}
	}
};

export default Manipulator;
